<div class="diff-container">
  @for (item of diff(); track $index) {
    <div class="diff-container-item">
      <span class="diff-path">{{ item.path }}:</span>
      {{ item.__old }}
      <mat-icon>trending_flat</mat-icon>
      {{ item.__new }}
    </div>
  }
</div>
